/**
 * Converts a string to sentence case
 * Sentence case: First letter of each word is capitalized, rest are lowercase
 *
 * @param {string} str - The string to convert
 * @returns {string} - The string in sentence case
 *
 * @example
 * toSentenceCase("cv / resume") // "Cv / Resume"
 * toSentenceCase("manual handling") // "Manual Handling"
 * toSentenceCase("cscscard") // "Cscscard"
 */
export const toSentenceCase = (str) => {
  if (!str || typeof str !== "string") {
    return str;
  }

  // Split by spaces and process each word
  return str
    .split(/\s+/)
    .map((word) => {
      // Handle empty strings
      if (!word) return word;

      // Capitalize first letter, lowercase the rest
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
